
import { Component, Vue } from "vue-property-decorator"
import { Formatting } from "../util/formatting"
const dateFormat = new Formatting.DateFormatting()

import MyWorkStatsQuery from "../graphql/workreport/myworkstats.graphql"

@Component({
    apollo: {
        myWorkStats: {
            query: MyWorkStatsQuery,
            pollInterval: 300000
        }
    }
})
export default class MyWorkStats extends Vue {
    myWorkStats?: any

    formatDuration(duration: number) {
        return duration ? dateFormat.duration(duration) : ""
    }

    periodShouldBeShown(period: string) {
        if (this.myWorkStats[period].work) {
            if (period == "week" && this.myWorkStats.week.work != this.myWorkStats.day.work) return true
            if (period == "month" && this.myWorkStats.month.work != this.myWorkStats.week.work) return true
            if (period == "day") return true
        }
        return false
    }

    refresh() {
        console.log("refresh my work stats")
        if (this.$apollo.queries.myWorkStats && typeof this.$apollo.queries.myWorkStats.refetch == "function")
            this.$apollo.queries.myWorkStats.refetch()
    }
}
